const routes = [
  {
    index: true,
    label: 'Brian Morris',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Events',
    path: '/events',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
